module.exports = __webpack_public_path__ + "img/storm.dd196953.svg";